// Tier
const Listtier = () => import('@/views/setting/tier')
const Formtier = () => import('@/views/setting/tier/form')

export default {
    path: 'tier',
    redirect: '/tier',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'tier',
            component: Listtier,
            meta: {
                link: 'tier',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Tier', active: true },
                ],
                pageTitle: 'Tier'
            }
        },
        {
            path: 'add',
            name: 'addtier',
            component: Formtier,
            meta: {
                link: 'tier',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Tier', url: '/tier' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Tier'
            }
        },
        {
            path: 'edit/:id',
            name: 'edittier',
            component: Formtier,
            meta: {
                link: 'tier',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Tier', url: '/tier' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Tier'
            }
        },
    ]
}